import React, {
  useRef,
  useState,
  useEffect,
  useContext,
} from "react";

import { createPortal } from "react-dom";

import { PageNavContext } from "../../FunctionalPageLogin";

import "../popupsright.css";
import "./BCButtonWithDropdown.css";

import bazeleconta from "../../images/bazeleconta.png";
import contafinanciaraone from "../../images/contafinanciara.png";
import contaprimara from "../../images/contaprimara.png";
import contabilitateaplicata from "../../images/contabilitateaplicata.png";
import testeconta from '../../images/testeconta.png';


import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronUp,
  faChevronDown,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";


/* =====================================================
   TOATE CURSURILE DISPONIBILE
===================================================== */


const allCourses = [
  {
    id: 1,
    name: "Bazele contabilitatii",
    icon: bazeleconta,
    color: "teal",
  },
  {
    id: 2,
    name: "Contabilitate financiara",
    icon: contafinanciaraone,
    color: "orange",
  },
  {
    id: 5,
    name: "Teste de contabilitate",
    icon: testeconta,
    color: "blue",
  },
  {
    id: 3,
    name: "Contabilitate primara",
    icon: contaprimara,
    color: "green",
  },
  {
    id: 4,
    name: "Contabilitate aplicata",
    icon: contabilitateaplicata,
    color: "purple",
  },
];



const BCButtonWithDropdown = () => {

  const btnRef = useRef(null);
  const popupRef = useRef(null);

  const pageNav = useContext(PageNavContext);

  


  /* =====================================================
     STATE POPUP
  ===================================================== */

  const [isVisible, setIsVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);


  
const [showCourseTip, setShowCourseTip] = useState(false);

useEffect(() => {
  const alreadySeen = localStorage.getItem(
    "contalearn-course-tip-seen"
  );

  if (!alreadySeen) {
    setShowCourseTip(true);
  }
}, []);

const dismissCourseTip = () => {
  localStorage.setItem(
    "contalearn-course-tip-seen",
    "true"
  );

  setShowCourseTip(false);
};



const goToAllCourses = () => {
  dismissCourseTip();

  if (pageNav) {
    pageNav("CoursesInPlace");
  }
};


  const [isMobile, setIsMobile] = useState(
    () => window.innerWidth <= 768
  );


  /* =====================================================
     CURSURI BIFATE
  ===================================================== */

  const [enrolledCourses, setEnrolledCourses] = useState(() => {

    const saved =
      localStorage.getItem("enrolledCourses");

    if (!saved) {
      return [1];
    }

    try {

      const parsed = JSON.parse(saved);

      return Array.isArray(parsed)
        ? parsed.map(Number)
        : [1];

    } catch {

      return [1];

    }
  });


  /* =====================================================
     CURS SELECTAT
  ===================================================== */

  const [selectedCourseId, setSelectedCourseId] = useState(() => {

    const saved =
      localStorage.getItem("selectedCourseId");

    const parsed =
      saved
        ? Number(saved)
        : 1;

 
return [1, 2, 3, 4, 5].includes(parsed)
  ? parsed
  : 1;

  });


  /* =====================================================
     CURSUL SELECTAT
  ===================================================== */

  const selectedCourse =
    allCourses.find(
      (course) => course.id === selectedCourseId
    ) || allCourses[0];


  /* =====================================================
     DESCHIDE POPUP
  ===================================================== */


const openPopup = () => {
  dismissCourseTip();

  if (isVisible && isOpen) {
    return;
  }

  setIsVisible(true);

  requestAnimationFrame(() => {
    setIsOpen(true);
  });
};


  /* =====================================================
     INCHIDE POPUP
  ===================================================== */

  const closePopup = () => {

    if (!isVisible) {
      return;
    }

    setIsOpen(false);
  };


  /* =====================================================
     RESPONSIVE
  ===================================================== */

  useEffect(() => {

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener(
      "resize",
      handleResize
    );

    return () => {
      window.removeEventListener(
        "resize",
        handleResize
      );
    };

  }, []);


  /* =====================================================
     ASCULTA MODIFICAREA CURSURILOR BIFATE
  ===================================================== */

  useEffect(() => {

    const handleCoursesUpdate = (event) => {

      const courses =
        Array.isArray(event.detail)
          ? event.detail.map(Number)
          : [];

      setEnrolledCourses(courses);
    };

    window.addEventListener(
      "coursesUpdated",
      handleCoursesUpdate
    );

    return () => {
      window.removeEventListener(
        "coursesUpdated",
        handleCoursesUpdate
      );
    };

  }, []);


  /* =====================================================
     ASCULTA SCHIMBAREA CURSULUI SELECTAT
  ===================================================== */

  useEffect(() => {

    const handleCourseSelected = (event) => {

      const courseId =
        Number(event.detail);

 if (![1, 2, 3, 4, 5].includes(courseId)) {
  return;
}

      setSelectedCourseId(courseId);
    };

    window.addEventListener(
      "courseSelected",
      handleCourseSelected
    );

    return () => {
      window.removeEventListener(
        "courseSelected",
        handleCourseSelected
      );
    };

  }, []);


  /* =====================================================
     RECITESTE LOCAL STORAGE LA DESCHIDERE
  ===================================================== */

  useEffect(() => {

    if (!isOpen) {
      return;
    }

    const savedCourses =
      localStorage.getItem("enrolledCourses");

    if (!savedCourses) {
      setEnrolledCourses([]);
      return;
    }

    try {

      const parsed =
        JSON.parse(savedCourses);

      setEnrolledCourses(
        Array.isArray(parsed)
          ? parsed.map(Number)
          : []
      );

    } catch {

      setEnrolledCourses([]);

    }

  }, [isOpen]);


  /* =====================================================
     SELECTEAZA CURS
  ===================================================== */

  const handleCourseClick = (courseId) => {

    const numericCourseId =
      Number(courseId);

   if (![1, 2, 3, 4, 5].includes(numericCourseId)) {
  return;
}

    setSelectedCourseId(
      numericCourseId
    );

    localStorage.setItem(
      "selectedCourseId",
      String(numericCourseId)
    );

    window.dispatchEvent(
      new CustomEvent(
        "courseSelected",
        {
          detail: numericCourseId,
        }
      )
    );

    closePopup();

    if (pageNav) {
      pageNav("Invata");
    }
  };


  /* =====================================================
     CLICK IN AFARA POPUP-ULUI
  ===================================================== */

  useEffect(() => {

    const handleClickOutside = (event) => {

      if (
        isVisible &&
        popupRef.current &&
        btnRef.current &&
        !popupRef.current.contains(event.target) &&
        !btnRef.current.contains(event.target)
      ) {
        closePopup();
      }
    };

    document.addEventListener(
      "mousedown",
      handleClickOutside
    );

    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );
    };

  }, [isVisible]);


  /* =====================================================
     ASCUNDE POPUP DUPA ANIMATIE
  ===================================================== */

  useEffect(() => {

    if (!isVisible) {
      return;
    }

    const closeTimer =
      setTimeout(() => {

        if (!isOpen) {
          setIsVisible(false);
        }

      }, 280);

    return () => {
      clearTimeout(closeTimer);
    };

  }, [isVisible, isOpen]);


  /* =====================================================
     CLASA PE BODY
  ===================================================== */

  useEffect(() => {

    if (isOpen) {

      document.body.classList.add(
        "stats-popup-open"
      );

    } else {

      document.body.classList.remove(
        "stats-popup-open"
      );

    }

    return () => {

      document.body.classList.remove(
        "stats-popup-open"
      );

    };

  }, [isOpen]);


  /* =====================================================
     ESC INCHIDE POPUP
  ===================================================== */

  useEffect(() => {

    if (!isVisible) {
      return;
    }

    const onKeyDown = (event) => {

      if (event.key === "Escape") {
        closePopup();
      }

    };

    document.addEventListener(
      "keydown",
      onKeyDown
    );

    return () => {

      document.removeEventListener(
        "keydown",
        onKeyDown
      );

    };

  }, [isVisible]);


  /* =====================================================
     CURSURI CARE AU BIFA
  ===================================================== */

  const visibleCourses =
    allCourses.filter((course) =>
      enrolledCourses.includes(course.id)
    );


  /* =====================================================
     RETURN
  ===================================================== */

  return (

    <div className="first-main-pagi-bc-wrapper">


      {/* =====================================================
          BUTON SCHIMBA CURS
      ===================================================== */}

      <div
        ref={btnRef}
        className="first-main-pagi-icon-bc"
        onClick={
          isOpen
            ? closePopup
            : openPopup
        }
        role="button"
        tabIndex={0}
        aria-expanded={isOpen}
        aria-label="Schimba cursul"

        onKeyDown={(event) => {

          if (
            event.key === "Enter" ||
            event.key === " "
          ) {

            event.preventDefault();

            if (isOpen) {
              closePopup();
            } else {
              openPopup();
            }

          }

        }}
      >

        <img
          src={selectedCourse.icon}
          alt={selectedCourse.name}
          className="first-main-pagi-stats-icon-lessons"
        />

        <span className="course-switch-text">
          Schimba cursul
        </span>

        <FontAwesomeIcon
          icon={
            isOpen
              ? faChevronUp
              : faChevronDown
          }
          className="course-switch-arrow"
          aria-hidden="true"
        />

      </div>



{showCourseTip && !isOpen && (
  <div
    className="bc-course-discovery-tip"
    role="region"
    aria-label="Descopera cursurile ContaLearn"
  >
    <span className="bc-course-discovery-tip-arrow" />

    <button
      type="button"
      className="bc-course-discovery-tip-close"
      onClick={dismissCourseTip}
      aria-label="Inchide mesajul"
    >
      ×
    </button>

    <div className="bc-course-discovery-tip-content">
    
      <p>
        Exploreaza toate cursurile disponibile in ContaLearn.
      </p>

      <button
        type="button"
        className="bc-course-discovery-tip-action"
        onClick={goToAllCourses}
      >
        Vezi cursurile
        <FontAwesomeIcon icon={faChevronRight} />
      </button>
    </div>
  </div>
)}


      {/* =====================================================
          POPUP
      ===================================================== */}

      {isVisible && createPortal(

        <>

          <div
            className={`
              first-main-pagi-overlay
              first-main-pagi-bc-overlay
              ${isOpen ? "open" : ""}
            `}
            onClick={closePopup}
          />


          <div
            ref={popupRef}
            className={`
              first-main-pagi-popup
              first-main-pagi-bc-popup
              first-main-pagi-bc-popup-anim
              ${isOpen ? "open" : ""}
              ${isMobile ? "mobile" : "desktop"}
            `}
          >


            {/* HEADER */}

            <div className="first-main-pagi-popup-header">
              Cursurile mele
            </div>


            {/* =====================================================
                DOAR CURSURILE BIFATE
            ===================================================== */}

     {visibleCourses.map((course) => {

  const isSelected =
    selectedCourseId === course.id;

  return (
    <div
      key={course.id}
      className={`bc-course-card ${
        isSelected ? "selected" : ""
      }`}
      onClick={() =>
        handleCourseClick(course.id)
      }
    >

      <div className="bc-course-card-icon">
        <img
          src={course.icon}
          alt={course.name}
        />
      </div>

      <div className="bc-course-card-content">

        <div className="bc-course-card-title">
          {course.name}
        </div>

        <div className="bc-course-card-meta">
          Curs activ
        </div>

       

      </div>

      <div className="bc-course-card-action">
        {isSelected ? (
          <div className="bc-course-card-check">
            ✓
          </div>
        ) : (
          <FontAwesomeIcon
            icon={faChevronRight}
            className="bc-course-card-chevron"
          />
        )}
      </div>

    </div>
  );
})}


            {/* =====================================================
                NICIUN CURS BIFAT
            ===================================================== */}

            {visibleCourses.length === 0 && (

              <div
                className="first-main-pagi-popup-item"
                style={{
                  cursor: "default",
                  color: "#7b8794",
                }}
              >
                Nu ai niciun curs adaugat.
              </div>

            )}


            {/* =====================================================
                ADAUGA CURS
            ===================================================== */}
{visibleCourses.length < allCourses.length ? (
  <div
    className="bc-course-add-card"
    onClick={() => {
      closePopup();

      if (pageNav) {
        pageNav("CoursesInPlace");
      }
    }}
  >
    <div className="bc-course-add-icon" />

    <div className="bc-course-add-content">
      <div className="bc-course-add-title">
        Adauga un curs
      </div>

      <div className="bc-course-add-subtitle">
        Descopera mai multe cursuri disponibile.
      </div>
    </div>

    <FontAwesomeIcon
      icon={faChevronRight}
      className="bc-course-card-chevron"
    />
  </div>
) : (
  <button
    type="button"
    className="bc-view-all-courses"
    onClick={() => {
      closePopup();

      if (pageNav) {
        pageNav("CoursesInPlace");
      }
    }}
  >
    Vezi toate cursurile

    <FontAwesomeIcon
      icon={faChevronRight}
      className="bc-view-all-courses-arrow"
    />
  </button>
)}


          </div>

        </>,

        document.body

      )}

    </div>

  );
};


export default BCButtonWithDropdown;